export default function(ngModule) {
    ngModule.factory('ScannerInstance', function(BaseClass,$q, $http) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function ScannerInstance(attributes) {
            _.assign(this,attributes);
        }
        ScannerInstance.modelName = 'ScannerInstance';


        BaseClass.apply(ScannerInstance);

        ScannerInstance.configureApi('/scanner/:scanner_type_guid/instance/:guid');
        ScannerInstance.prototype.expire = function() {
            return $http.post(`/scanner/${this.scanner_type_id}/instance/${this.guid}/expire`)
                .then(res => res.data);
        };
        ScannerInstance.prototype.toString = function() { return this.name; };

        ScannerInstance.prototype.$queryPings = function() {
            return $http.get(`/scanner/${this.scanner_type_id}/instance/${this.guid}/pings`)
                .then(res => {
                    this.pings = res.data;
                    return res.data;
                });
        };

        return ScannerInstance;
    });
}
